import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import { ImgComparisonSlider } from '@img-comparison-slider/react';
import { getImageDimension, getImages } from './helpers';

export const BeforeAfterSlider = ({ beforeAfterSlider, currentBreakpoint }) => {
  const { sectionHeadings, images } = R.pick(
    ['sectionHeadings', 'images'],
    beforeAfterSlider,
  );
  const { heading, subheading, introduction } = R.pick(
    ['heading', 'subheading', 'introduction'],
    sectionHeadings,
  );
  const { beforeImage, afterImage, slideButtonImage } = getImages({
    images,
    currentBreakpoint,
  });
  const dimension = getImageDimension({
    imageSrcSet: R.pathOr([], ['slideButton', 'imageSrcSet'], images),
    currentBreakpoint,
  });

  return (
    <div className="before-after-slider">
      {(heading || subheading || introduction) && (
        <div className="cell">
          {!!heading && (
            <Heading extraClass="before-after-slider__heading" level={2}>
              {heading}
            </Heading>
          )}

          {!!subheading && (
            <Paragraph extraClass="before-after-slider__subheading">
              {subheading}
            </Paragraph>
          )}

          {!!introduction && <Paragraph>{introduction}</Paragraph>}
        </div>
      )}

      <div className="before-after-slider__image">
        <ImgComparisonSlider>
          <img
            slot="first"
            src={beforeImage}
            alt={R.path(['before', 'alt'], images)}
          />

          <img
            slot="second"
            src={afterImage}
            alt={R.path(['after', 'alt'], images)}
          />

          <div
            slot="handle"
            className="handle"
            style={{ width: R.propOr(100, 'width', dimension) }}
          >
            <img
              src={slideButtonImage}
              alt={R.path(['slideButton', 'alt'], images)}
            />
          </div>
        </ImgComparisonSlider>
      </div>
    </div>
  );
};

BeforeAfterSlider.propTypes = {
  sectionHeadings: PropTypes.shape({
    heading: PropTypes.string,
    subheading: PropTypes.string,
    introduction: PropTypes.string,
  }),
  images: PropTypes.instanceOf(PropTypes.object),
  currentBreakpoint: PropTypes.string.isRequired,
};
